import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderManagerChanged(props: TypicalMessageProps) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            optionsKey="manager"
            replace={{was: '—'}}
            messageKeysWithStatusId={['was', 'became']}
    />;
}
